<svelte:options
  customElement={{
    tag: "radial-chart",
    shadow: "none",
    props: {
      title: {
        type: "String",
      },
      series: {
        type: "Array",
      },
    },
  }}
/>

<script>
  import ApexCharts from "apexcharts";
  let { title, series } = $props();

  let ready = $state(false);

  function init(element) {
    // Prevent the chart from being updated by Phoenix LiveView once we're connected.
    $host().setAttribute("phx-update", "ignore");
    $host().setAttribute("class", "tw:flex");

    const chart = new ApexCharts(element, {
      chart: {
        type: "radialBar",
        toolbar: { show: false },
        height: 225,
        width: 225,
        animations: {
          enabled: false,
        },
        events: {
          mounted: () => {
            ready = true;
          },
        },
      },
      labels: [title],
      legend: {
        show: false,
      },
      states: {
        hover: {
          filter: {
            type: "none",
          },
        },
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            enabled: false,
            showOn: false,
            name: {
              show: true,
              color: "oklch(0.442 0.017 285.786)",
              fontFamily: "Inter",
              fontSize: "10px",
              offsetY: 20,
            },
            value: {
              color: "#18181b",
              fontFamily: "Inter",
              fontSize: "24px",
              fontWeight: 800,
              offsetY: -8,
            },
          },
        },
      },
      colors: ["#84cc16", "#dc2626"],
      stroke: {
        lineCap: "round",
      },
      series: series,
      tooltip: {
        enabled: false,
      },
    });
    chart.render();
  }
</script>

<div
  class={[
    "tw:transition-opacity",
    ready ? "tw:opacity-100" : "tw:opacity-0",
    "tw:isolate tw:flex tw:aspect-square tw:flex-col tw:justify-start tw:overflow-hidden tw:rounded-lg tw:bg-white tw:px-4 tw:shadow tw:ring-1 tw:ring-zinc-900/5 tw:transition-all tw:delay-700 tw:duration-800",
  ]}
>
  <figure class="tw:relative tw:isolate tw:-mx-4 tw:flex">
    <div class={[]} {@attach init}></div>
  </figure>
</div>
